import { render, staticRenderFns } from "./OpsiyonListesi.vue?vue&type=template&id=84fc9f22&scoped=true&"
import script from "./OpsiyonListesi.vue?vue&type=script&lang=js&"
export * from "./OpsiyonListesi.vue?vue&type=script&lang=js&"
import style0 from "./OpsiyonListesi.vue?vue&type=style&index=0&id=84fc9f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84fc9f22",
  null
  
)

export default component.exports